import profileModule from "@/store/profile/module";
import store from "@/store";

export default function isUserRole() {
  const roles = Object.values(profileModule.state.profile.roles);

  const hasExpert = roles.includes("ROLE_EXPERT");
  const hasIssuer = roles.includes("ROLE_ISSUER");
  const hasUser = roles.includes("ROLE_USER");

  if (hasExpert) {
    return "expert";
  }
  if (hasIssuer) {
    return "issuer";
  }
  if (hasUser) {
    return "user";
  }

  return null;
}

export function changeRole() {
  const roles = Object.values(profileModule.state.profile.roles);
  const hasTest = roles.includes("ROLE_TEST");
  if (!hasTest) {
    return false;
  }

  let testRole = localStorage.getItem("testRole");

  if (testRole === null) {
    testRole = "true";
    localStorage.setItem("testRole", testRole);
    checkTestRole();
    return true;
  }

  testRole = testRole === "true" ? "false" : "true";
  localStorage.setItem("testRole", testRole);
  checkTestRole();
  return true;
}

export function checkTestRole() {
  const testRole = localStorage.getItem("testRole");

  if (!testRole) {
    store.commit("profile/setTestRole", false);
    return false;
  }
  const isTestRole = testRole === "true";
  store.commit("profile/setTestRole", isTestRole);
  return isTestRole;
}


// логика не трогает роль TEST и ADMIN
// все наши роли
// ROLE_EXPERT
// ROLE_ISSUER
// ROLE_USER
// ROLE_TEST
// ROLE_ADMIN
// ZOZOZO
